import { CSSProperties, FC, ReactNode } from 'react';
import styles from './BannerCard.module.scss';

type Props = {
  title?: ReactNode;
  children: ReactNode;
  color?: string;
  textColor?: string;
  className?: string;
  style?: CSSProperties;
}

const BannerCard: FC<Props> = ({ title, children, color = 'var(--light-blue-50)', textColor = 'var(--light-blue-800)', className, style }) => {
  return (
    <div
      className={`${styles.card} ${className ?? ''}`}
      style={{ backgroundColor: color, color: textColor, ...style }}
    >
      <div className={styles.container}>
        {title && <p className={styles.title}>{title}</p>}
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default BannerCard;
